import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { IntegrationEvent } from "../_types/integration-event";

@Injectable({
    providedIn: 'root',
})

export class IntegrationEventsService extends Service<IntegrationEvent> {
  public override type = 'integrationEvents';
  public override url = 'attendance/integrationEvents';   
}
